export class Timezone {
  public token: string;
  public zoneId: string;
  public active: boolean;
  public translationKey: string;
}
